export default class Tyre {

    constructor(data) {
        this.id = null;
        this.name = null;
        this.age = null;
        this.profileDepth = null;
        this.note = null;
        this.state = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/tyre.model.js